import { render } from "./OrganisationUserShiftsAdminPage.vue?vue&type=template&id=8e61380c"
import script from "./OrganisationUserShiftsAdminPage.vue?vue&type=script&lang=js"
export * from "./OrganisationUserShiftsAdminPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__